import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import {
  A11yService,
  DocumentTitleService,
  LocalizationService,
  TrackerService,
  UserPreferencesService,
} from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';
import { Settings as LuxonSettings } from 'luxon';
import { EngagedLearnerService } from './shared/services/engaged-learner.service';

import { UserTourService } from '@degreed/lxp/services/user';
import { TagRatingService } from './tags/services/tag-rating.service';

declare global {
  interface Window {
    Osano: any;
  }
}

@Component({
  selector: 'dgx-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit {
  @HostListener('document:mousedown')
  public handleMouseClick() {
    this.a11yService.addMouseFocus();
  }

  @HostListener('document:keyup.tab')
  @HostListener('document:keyup.shift.tab')
  public handleKeyUp() {
    this.a11yService.removeMouseFocus();
  }

  constructor(
    private documentTitleService: DocumentTitleService,
    private tagRatingService: TagRatingService,
    private engagedLearnerService: EngagedLearnerService,
    private userTourService: UserTourService,
    private trackerService: TrackerService,
    private a11yService: A11yService,
    private localizationService: LocalizationService,
    private authService: AuthService,
    private userPreferencesService: UserPreferencesService
  ) {}

  public ngOnInit(): void {
    // Set the document title tag value for a given Angular route
    // after the navigation ends is successful
    this.documentTitleService.register();

    // Some Tag rating email notification urls include properties to trigger modals
    this.tagRatingService.checkForRatingEmails();

    // Congratulate user for achieving engaged learner status
    this.engagedLearnerService.checkForEngagedLearnerStatusChange();

    // Start chameleon tour for registered orgs
    this.userTourService.loadTourIfEnabled();

    // set locale based on user state and initialize user preferences
    this.authService.authUser$.subscribe((authUser) => {
      this.localizationService.userLocale = authUser?.viewerProfile?.localeId;
      // Use what's set by the user for locale instead of browser defaults
      LuxonSettings.defaultLocale = this.localizationService.userLocale;

      // Initialize user preferences with the user profile key
      this.userPreferencesService.initUserPreferences(
        authUser?.viewerProfile?.userProfileKey?.toString()
      );
    });
  }

  public ngAfterViewInit() {
    // Degreed Amplitude Tracking
    this.trackerService.trackIdentify().subscribe();
  }
}
